import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KEY = "xenia_cookie_consent";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ at: new Date().toISOString(), v: 1 }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-stone-900 text-stone-50 p-4 md:p-5 border-t border-stone-700 shadow-2xl" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1 text-sm leading-relaxed">
          <p className="font-medium mb-1">{t("cookie_banner.title")}</p>
          <p className="text-stone-300">
            {t("cookie_banner.body")}{" "}
            <Link to="/cookie-policy" className="text-sky-300 underline underline-offset-2">{t("privacy.view_cookie")}</Link> ·{" "}
            <Link to="/privacy" className="text-sky-300 underline underline-offset-2">{t("privacy.view_privacy")}</Link>
          </p>
        </div>
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="bg-blue-700 hover:bg-blue-600 text-white px-6 py-3 text-sm rounded-sm whitespace-nowrap"
        >
          {t("cookie_banner.accept")}
        </button>
      </div>
    </div>
  );
}
